import { render, staticRenderFns } from "./_CandidatePanel.vue?vue&type=template&id=2659358e&"
import script from "./_CandidatePanel.vue?vue&type=script&lang=js&"
export * from "./_CandidatePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports